import { DimensionUnit, PalletSpec, PalletFitResult } from '@freight-cbm/shared-types';
import { convertToMeters } from './units';

export function calcPalletFit(
  cartonL: number,
  cartonW: number,
  cartonH: number,
  dimUnit: DimensionUnit,
  pallet: PalletSpec,
): PalletFitResult {
  const cl = convertToMeters(cartonL, dimUnit);
  const cw = convertToMeters(cartonW, dimUnit);
  const ch = convertToMeters(cartonH, dimUnit);

  if (cl <= 0 || cw <= 0 || ch <= 0 || isNaN(cl) || isNaN(cw) || isNaN(ch)) {
    return {
      palletType: pallet.type,
      cartonsPerLayer: 0,
      layers: 0,
      totalCartons: 0,
      palletCount: 0,
      volumeUtilization: 0,
    };
  }

  const { cartonsPerLayer } = calcOrientation(cl, cw, pallet.length, pallet.width);
  const layers = Math.floor(pallet.maxStackHeight / ch);
  const totalCartons = cartonsPerLayer * layers;
  const volumeUtilization =
    (cl * cw * ch * totalCartons) /
    (pallet.length * pallet.width * pallet.maxStackHeight) *
    100;

  return {
    palletType: pallet.type,
    cartonsPerLayer,
    layers,
    totalCartons,
    palletCount: 0,
    volumeUtilization: Math.min(volumeUtilization, 100),
  };
}

function calcOrientation(
  cl: number,
  cw: number,
  palletL: number,
  palletW: number,
): { cartonsPerLayer: number } {
  const orientation1 = Math.floor(palletL / cl) * Math.floor(palletW / cw);
  const orientation2 = Math.floor(palletL / cw) * Math.floor(palletW / cl);
  return { cartonsPerLayer: Math.max(orientation1, orientation2) };
}
